import React from 'react';
import { useTranslation } from '../../../../shared/i18n/translate/useTranslation';

export const MyBookingsNoResults = () => {
	const { t } = useTranslation();

	return <p>{t('parking_landing_your_bookings_no_results')}</p>;
};
